module.exports = __webpack_public_path__ + "static/media/accessorials-active.1ae4206f.svg";